// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useEffect} from 'react';
export const use_webos_scroll = (ignore_ua?: boolean)=>{
    useEffect(()=>{
        if (navigator.userAgent.indexOf('Web0S')===-1 && !ignore_ua)
            return;
        const scroll_hdl = e=>{
            const scroll_el = document.getElementById('for_webos_scroll')
                || window;
            if (e.key == 'ArrowDown')
                scroll_el.scrollBy({top: 60, behavior: 'smooth'});
            else if (e.key == 'ArrowRight')
                scroll_el.scrollBy({top: 60, behavior: 'smooth'});
            else if (e.key == 'ArrowUp')
                scroll_el.scrollBy({top: -60, behavior: 'smooth'});
            else if (e.key == 'ArrowLeft')
                scroll_el.scrollBy({top: -60, behavior: 'smooth'});
        };
        document.addEventListener('keydown', scroll_hdl);
        return ()=>{
            document.removeEventListener('keydown', scroll_hdl);
        };
    }, []);
    useEffect(()=>{
        if (navigator.userAgent.indexOf('Web0S')===-1 && !ignore_ua)
            return;
        const scroll_hdl = e=>{
            const scroll_el = document.getElementById('for_webos_scroll')
                || window;
            if (e.deltaY > 0)
                scroll_el.scrollBy({top: 60, behavior: 'smooth'});
            else
                scroll_el.scrollBy({top: -60, behavior: 'smooth'});
        };
        document.addEventListener('wheel', scroll_hdl);
        return ()=>{
            document.removeEventListener('wheel', scroll_hdl);
        };
    }, []);
};
